exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".app-main[data-v-6beed8bc]{min-height:calc(100vh - 90px);width:100%;position:relative;overflow:hidden;padding:8px}.fixed-header+.app-main[data-v-6beed8bc]{padding-top:50px}.hasTagsView .app-main[data-v-6beed8bc]{min-height:calc(100vh - 84px)}.hasTagsView .fixed-header+.app-main[data-v-6beed8bc]{padding-top:84px}.z9999[data-v-6beed8bc]{z-index:9999 !important}\n", ""]);

// exports
